import type { RadioGroupProps as ChordsRadioGroupProps } from '~/chords/RadioGroup';
import { RadioGroup as ChordsRadioGroup } from '~/chords/RadioGroup';
import type { ContainerComponentProps } from '~/components/WithClassNameHoc';
import { withClassNameHoc } from '~/components/WithClassNameHoc';

export type RadioGroupProps = ContainerComponentProps<ChordsRadioGroupProps>;
export const RadioGroup = withClassNameHoc(ChordsRadioGroup);
